<template>
  <div class="container">
    <!--<div class="title"><span>首页</span>>  检查预约机构</div>-->
    <div class="jgfl">
      <div class="item">
        <div class="items">
          <p >科室选择 <i></i></p>
          <ul>
            <li :class="active === 'all' ? 'active': ''" @click="depatTab('all', null)">不限</li>
            <li v-for="(item, index) in deparList" :class="active == index ? 'active': ''" :key="item.id" @click="depatTab(index, item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="items">
          <p>切换地区 <i></i></p>
          <ul>
            <li :class="active2 === 'all' ? 'active': ''" @click="areaTab('all', null)">不限</li>
            <li v-for="(item, index) in areaList" :class="active2 == index ? 'active': ''" :key="item.id" @click="areaTab(index, item.id)">{{item.name}}</li>
          </ul>
        </div>
      </div>
      <!--<div class="item">-->
        <!--<p class="t">检查预约机构分类:</p>    <p class="res"><span :class="active2 == 'all' ? 'active': ''" @click="areaTab('all', '')">全部</span>-->
        <!--<span v-for="(item, index) in areaList" :key="item.id" @click="areaTab(index, item.id)" :class="active2 == index ? 'active': ''">{{item.name}}</span>-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="item item2">-->

        <!--<p class="t">检查预约科室分类:</p>    <p class="res"><span :class="active == 'all' ? 'active': ''" @click="depatTab('all', '')">全部</span>  <span v-for="(item, index) in deparList" :key="item.id" @click="depatTab(index, item.id)" :class="active == index ? 'active': ''">{{item.name}}</span> </p>-->
      <!--</div>-->
    </div>
    <div class="shaixuan">
      <div class="item ac">综合 <i class="el-icon-caret-top"></i></div>
      <div class="item">好评量 <i class="el-icon-caret-bottom"></i></div>
      <div class="item">问诊量 <i class="el-icon-caret-bottom"></i></div>
      <div class="item">价格 <i class="el-icon-caret-bottom"></i></div>
    </div>
    <div class="yybox">
      <div class="item" @click="goinfo(item.id)" v-for="item in list3" :key="item.id">
        <img :src="item.picUrl" alt="">
        <div class="box">
          <div class="tit">{{item.name}}</div>
          <div class="jg">￥{{item.salesPrice}}</div>
          <div class="js">{{item.introduction}}</div>
          <el-button class="btn">立即预约</el-button>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination
      background
      layout="pager"
      :total="total"
      @current-change="chanePage"
      >
    </el-pagination>
    </div>

  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          showHeader: false,
          active: 'all',
          active2: 'all',
          areaList: [],
          deparList: [],
          list3: [],
          categoryDepartment: null,
          parentId: null,
          current: 1,
          total: 0
        }
    },
    methods: {
      goinfo(id) {
        this.$router.push({
          path: `/xxjs?id=${id}`
        })
        // this.showVisible = true
      },
      depatTab(index, id) {
        this.active = index
        this.categoryDepartment = id
        this.hospitalList()
        console.log(index, id)
      },
      areaTab(index, id) {
        this.active2 = index
        this.parentId = id
        this.hospitalList()
        console.log(index, id)
      },
      hospitalList() {
        server.hospitalListPage({
          size: 10,
          current: this.current,
          parentId: this.active2 == 'all' ? null : this.parentId,
          categoryDepartment: this.active == 'all' ? null : this.categoryDepartment
        }).then((res) => {
          this.list3 = res.data.records
          this.total = res.data.total
        })
      },
      chanePage(e) {
        this.current = e
        this.hospitalList()
      },
    },

    mounted(){
      server.department().then((res) => {
        this.deparList = res.data
        if (this.$route.query.type) {
          if (this.$route.query.type == '1') {
            this.categoryDepartment = this.$route.query.id
            this.active = this.$route.query.index
            this.hospitalList()
          } else {
            this.hospitalList()
          }
        }
      })
      server.area().then((res) => {
        console.log(res.data)
        this.areaList = res.data
        if (this.$route.query.type) {
          if (this.$route.query.type == '2') {
            this.parentId = this.$route.query.id
            this.active2 = this.$route.query.index
            this.hospitalList()
          } else {
            this.hospitalList()
          }
        }
      })

      this.hospitalList()
      // this.pageIndex = this.$filters.dateTime
      // this.getList()
    }

}
</script>
<style lang="scss" scoped>
  .container {
    width: 1370px;
    margin: 0 auto;
  }
 .title {
   padding: 10px 20px;
   background-color: #FFFFFF;
   margin: 20px 0;
   font-size: 16px;
   span {
     color: #5288F0;
   }

 }
  .jgfl {
    padding: 0 20px;
    background: #FFFFFF;
    border: 1px solid #F0F0F0;
    display: flex;
    margin-top: 20px;
    .item{
      width: calc(100% - 80px);
      .items{
        border-bottom: 2px dashed rgba(243, 243, 243, 1);
        line-height: 70px;
        display: flex;
        width: 100%;
        p{
          font-size: 16px;
          /*font-family: SourceHanSansCN;*/
          font-weight: 400;
          width: 100px;
          i{
            width: 1px;
            height: 38px;
            background: #F1F1F1;
            display: inline-block;
            vertical-align: middle;
            margin-left: 16px;
          }
        }
        ul{
          display: flex;
          width: calc(100% - 100px);
          flex-wrap: wrap;
          li{
            font-size: 16px;
            font-weight: 400;
            margin-left: 20px;
            cursor: pointer;
            &.active {
              color: #CB0E07;
            }
          }
        }
      }
    }
    .zk{
      font-size: 16px;
      font-weight: 400;
      color: #347AEE;
      margin-left: auto;
      cursor: pointer;
      line-height: 70px;
    }
  }
  .shaixuan {
    padding: 20px;
    background-color: #FFFFFF;
    margin: 25px 0;
    display: flex;
    .item {
      margin: 0 20px;
      &.ac {
        color: #FF7978;
      }
    }
  }
  .shaixuan {
    padding: 20px;
    background-color: #FFFFFF;
    margin: 25px 0;
    display: flex;
    .item {
      margin: 0 20px;
      &.ac {
        color: #FF7978;
      }
    }
  }
  .yybox {
    display: flex;
    justify-content: space-between;
    width: 1370px;
    flex-wrap: wrap;
    .item {
      width: calc(50% - 10px);
      padding: 20px;
      height: 190px;
      margin-bottom: 15px;
      background: #FFFFFF;
      border: 1px solid #e2e2e2;
      display: flex;
      transition: all 0.5s;
      cursor: pointer;
      /*box-shadow: 0 4px 8px #CB0E07;*/
      &:hover {
        box-shadow: 0 4px 8px #bababa;
        .btn {
          margin-right: 30px;
        }
      }
      .box {
        width: 100%;
      }
      img {
        width: 240px;
        height: 148px;
        display: block;
        margin-right: 15px;
        transition: all 0.5s;
      }
      .tit {
        font-size: 18px;
        color: #373737;
        font-weight: 400;
      }
      .jg {
        font-size: 14px;
        color: #FF5700;
        font-weight: bold;
        margin-top: 15px;
      }
      .js {
        font-size: 16px;
        color: #6F7576;
        line-height: 26px;
        height: 52px;
        overflow: hidden;
        text-overflow: ellipsis;  /* 超出部分省略号 */
        word-break: break-all;  /* break-all(允许在单词内换行。) */
        display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
        -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-line-clamp: 2; /* 显示的行数 */
      }
      .btn {
        background: #CB0E07;
        color: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        display: block;
        float: right;
        transition: all 0.5s;
      }
    }
  }
  .page {
    padding: 30px;
    text-align: center;
  }
  @media (max-width: 750px) {

    .container {
      width: 100%;
      margin-top: 60px;
      .jgfl .item {
        width: auto;
      }
      .jgfl .item .items {
        line-height: 40px;
      }
      .jgfl .item .items ul {
        display: block;
        li {
          float: left;
        }
      }
      .shaixuan{
        display: none;
      }
      .yybox {
        width: calc(100% - 20px);
        display: block;
        margin: 10px;
        .item {
          width: 100%;
          padding: 10px;
          height: auto;
          img {
            width: 100px;
            height: auto;
          }
          .box {
             width: calc(100% - 115px);
            .tit {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 16px;
            }
            .js {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 14px;
              webkit-line-clamp: 1;
              line-height: 26px;
              height: auto;
            }
            .jg {
              margin-top: 10px;
            }
            .btn {
              border-radius: 0;
            }
          }
        }
      }
    }
  }
</style>
